/* =====================================================================
   VEREDA · ficha de producto
   Galería · pack elegido · talla (una decisión; los demás pares heredan) · totales · añadir al carrito ·
   barra fija · buscador de talla. 06/10: el color, si lo hay, en círculos por par (ajuste «Colores»).
   18/10: la talla en botones (S · 35–38). «Misma talla en todos los pares» sale marcada: la talla se elige una vez, arriba, y
   cada par solo decide su color; sin marcar, cada par tiene sus propios botones. Precio por par junto al del pack (data-mt-par).
   Los importes que se enseñan usan la misma escalera que el descuento automático de Shopify y se calculan
   línea a línea, igual que el carrito, para que el total del botón sea el total del pago.
   27/10 (como Kintoe, datos.unColor): el color y la talla se eligen una sola vez, encima de los packs, y todos los pares del pack
   salen iguales; sin «Uno de cada» ni color par a par. Tras cada cambio se vuelve a pintar, para tachar lo agotado con lo elegido.
   ===================================================================== */
(() => {
  'use strict';
  const raiz = document.querySelector('[data-mt-producto]');
  if (!raiz) return;

  const $ = (sel, r = raiz) => r.querySelector(sel);
  const $$ = (sel, r = raiz) => Array.from(r.querySelectorAll(sel));
  const datos = JSON.parse($('[data-mt-datos]').textContent);
  const dinero = window.mtDinero;
  const plural = (n) => (n === 1 ? '1 par' : `${n} pares`);

  /* ---------- Galería ---------- */
  (function galeria() {
    const carril = $('[data-mt-carril]');
    if (!carril) return;
    const fotos = $$('[data-mt-foto]', carril);
    const minis = $$('[data-mt-mini]');
    const contador = $('[data-mt-foto-n]');
    if (fotos.length < 2) return;
    let actual = 0;
    const marcar = (i) => {
      if (i === actual) return;
      actual = i;
      if (contador) contador.textContent = String(i + 1);
      minis.forEach((m, k) => m.classList.toggle('es-activa', k === i));
      const mini = minis[i];
      if (mini && mini.parentElement.scrollWidth > mini.parentElement.clientWidth) {
        mini.parentElement.scrollTo({ left: mini.offsetLeft - mini.parentElement.clientWidth / 2 + mini.clientWidth / 2, behavior: 'smooth' });
      }
    };
    // 08/10 · al elegir un color en la ficha, la galería salta a la foto marcada con ese color (bloque «Foto de galería» → Color).
    raiz.addEventListener('mt:color', (e) => {
      const nombre = String((e.detail && e.detail.color) || '').trim().toLowerCase();
      if (!nombre) return;
      const i = fotos.findIndex((f) => (f.dataset.color || '').trim().toLowerCase() === nombre);
      if (i < 0 || i === actual) return;
      if (carril.scrollWidth > carril.clientWidth) {
        carril.scrollTo({ left: i * carril.clientWidth, behavior: 'smooth' }); // móvil: carrusel
      } else {
        fotos[i].scrollIntoView({ behavior: 'smooth', block: 'center' }); // escritorio: rejilla, se baja hasta la foto
      }
      marcar(i);
    });
    let pendiente = false;
    carril.addEventListener(
      'scroll',
      () => {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(() => {
          pendiente = false;
          if (carril.scrollWidth <= carril.clientWidth) return;
          marcar(Math.round(carril.scrollLeft / carril.clientWidth));
        });
      },
      { passive: true }
    );
    minis.forEach((mini, i) =>
      mini.addEventListener('click', () => {
        carril.scrollTo({ left: i * carril.clientWidth, behavior: 'smooth' });
        marcar(i);
      })
    );
    carril.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      if (carril.scrollWidth <= carril.clientWidth) return;
      e.preventDefault();
      const destino = Math.min(fotos.length - 1, Math.max(0, actual + (e.key === 'ArrowRight' ? 1 : -1)));
      carril.scrollTo({ left: destino * carril.clientWidth, behavior: 'smooth' });
    });
  })();

  /* ---------- Visor de fotos a pantalla completa (11/10) ---------- */
  // Al tocar una foto de la galería (o la lupa) se abre a pantalla completa con las fotos grandes; se pasa de una a otra
  // deslizando o con las flechas, y al tocar la foto se amplía 2,5 veces en el punto tocado (otro toque la devuelve).
  // Los vídeos de la galería no entran. Atrás en el móvil, Escape o la X cierran; al cerrar, la galería queda en la misma foto.
  (function visorFotos() {
    const carril = $('[data-mt-carril]');
    if (!carril || (window.Shopify && window.Shopify.designMode)) return; // en el editor, pulsar la foto elige su bloque
    const fotos = $$('[data-mt-foto]', carril);
    const conImagen = fotos.map((f, i) => ({ i, img: f.querySelector('img') })).filter((x) => x.img);
    if (!conImagen.length) return;
    const html = document.documentElement;
    const grande = (img) => {
      // la versión más ancha del srcset (1800 px); si no hay srcset, la que se ve
      const opciones = (img.getAttribute('srcset') || '').split(',').map((s) => s.trim().split(/\s+/)).filter((p) => p[0]);
      opciones.sort((a, b) => parseInt(b[1], 10) - parseInt(a[1], 10));
      return opciones.length ? opciones[0][0] : img.currentSrc || img.src;
    };
    const tactil = !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const flecha = (d) => `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${d}"/></svg>`;

    const visor = document.createElement('div');
    visor.className = 'mt-visor';
    visor.setAttribute('role', 'dialog');
    visor.setAttribute('aria-modal', 'true');
    visor.setAttribute('aria-label', 'Fotos del producto, ampliadas');
    visor.hidden = true;
    visor.innerHTML = `
      <div class="mt-visor__carril" data-visor-carril>${conImagen
        // de fondo, la foto pequeña de la galería (ya descargada): se ve al momento mientras llega la grande
        .map((x) => `<div class="mt-visor__foto"><img src="${grande(x.img)}" style="background-image:url('${x.img.currentSrc || x.img.src}')" alt="${(x.img.getAttribute('alt') || '').replace(/"/g, '&quot;')}" loading="lazy" decoding="async" draggable="false"></div>`)
        .join('')}</div>
      <div class="mt-visor__barra"><span class="mt-visor__cuenta mt-mono"><span data-visor-n>1</span> / ${conImagen.length}</span>
        <button type="button" class="mt-visor__cerrar" data-visor-cerrar aria-label="Cerrar">${flecha('M6 6l12 12M18 6 6 18')}</button></div>
      ${conImagen.length > 1 ? `<button type="button" class="mt-visor__flecha mt-visor__flecha--ant" data-visor-paso="-1" aria-label="Foto anterior">${flecha('M15 5l-7 7 7 7')}</button>
      <button type="button" class="mt-visor__flecha mt-visor__flecha--sig" data-visor-paso="1" aria-label="Foto siguiente">${flecha('M9 5l7 7-7 7')}</button>` : ''}
      <p class="mt-visor__pista">${tactil ? 'Toca la foto para ampliarla' : 'Haz clic en la foto para ampliarla'}</p>
      ${$('[data-mt-opciones]') || $('#elegir-pack') ? `<div class="mt-visor__comprar"><span class="mt-visor__precio" data-visor-precio></span>
        <button type="button" class="mt-btn mt-btn--primario mt-btn--s" data-visor-elegir>Elegir talla</button></div>` : ''}`;
    document.body.appendChild(visor);

    const pista = visor.querySelector('[data-visor-carril]');
    const marcos = Array.from(pista.children);
    const cuenta = visor.querySelector('[data-visor-n]');
    const cerrarBtn = visor.querySelector('[data-visor-cerrar]');
    // 20/10 (Clarity, research/11): quien se engancha a las fotos se iba desde aquí, sin precio ni botón. Abajo, el precio del pack
    // elegido y «Elegir talla», que cierra el visor y baja a la talla.
    const precioVisor = visor.querySelector('[data-visor-precio]');
    if (precioVisor) visor.classList.add('con-compra');
    const ponerPrecio = () => {
      const t = $('[data-mt-total]');
      const p = $('[data-mt-par]');
      if (precioVisor && t) precioVisor.innerHTML = `<b>${t.textContent.trim()}</b>${p && !p.hidden ? `<span>${p.textContent.trim()}</span>` : ''}`;
    };
    let abierto = false;
    let actual = 0;
    let volverA = null;

    // la foto que se ve y sus dos vecinas se piden ya (las demás esperan, loading="lazy")
    const cargar = (k) => [k - 1, k, k + 1].forEach((j) => { const im = marcos[j] && marcos[j].querySelector('img'); if (im && im.loading !== 'eager') im.loading = 'eager'; });
    const ir = (k, suave) => {
      actual = Math.min(conImagen.length - 1, Math.max(0, k));
      cargar(actual);
      pista.scrollTo({ left: actual * pista.clientWidth, behavior: suave ? 'smooth' : 'auto' });
      cuenta.textContent = String(actual + 1);
    };
    // la foto ocupa todo su hueco con object-fit: contain; esto da el rectángulo que se ve de verdad
    const dibujada = (img) => {
      const r = img.getBoundingClientRect();
      const nw = img.naturalWidth || r.width;
      const nh = img.naturalHeight || r.height;
      const e = Math.min(r.width / nw, r.height / nh);
      return { left: r.left + (r.width - nw * e) / 2, top: r.top + (r.height - nh * e) / 2, width: nw * e, height: nh * e };
    };
    const reducir = () => {
      const m = visor.querySelector('.mt-visor__foto.es-ampliada');
      if (!m) return;
      const img = m.querySelector('img');
      m.classList.remove('es-ampliada');
      visor.classList.remove('es-ampliado');
      img.style.width = '';
      m.scrollTo(0, 0);
    };
    const ampliar = (m, x, y) => {
      const img = m.querySelector('img');
      if (!img.naturalWidth) return; // aún sin cargar
      const r = dibujada(img);
      const fx = Math.min(1, Math.max(0, (x - r.left) / r.width));
      const fy = Math.min(1, Math.max(0, (y - r.top) / r.height));
      const ancho = r.width * 2.5;
      m.classList.add('es-ampliada');
      visor.classList.add('es-ampliado');
      img.style.width = `${ancho}px`;
      const alto = ancho * (img.naturalHeight / img.naturalWidth);
      m.scrollLeft = fx * ancho - m.clientWidth / 2;
      m.scrollTop = fy * alto - m.clientHeight / 2;
    };

    const abrir = (indiceGaleria) => {
      if (abierto) return;
      const k = Math.max(0, conImagen.findIndex((x) => x.i === indiceGaleria));
      volverA = document.activeElement;
      abierto = true;
      visor.hidden = false;
      html.classList.add('mt-bloqueo');
      ponerPrecio();
      ir(k, false); // sin esperar al siguiente fotograma: el visor ya tiene tamaño al quitarle hidden
      cerrarBtn.focus({ preventScroll: true });
      try { history.pushState({ mtVisor: true }, ''); } catch (e) { /* sin historial: se cierra igual con la X */ }
    };
    const cerrar = (desdeHistorial) => {
      if (!abierto) return;
      reducir();
      abierto = false;
      visor.hidden = true;
      html.classList.remove('mt-bloqueo');
      // la galería se queda en la foto que se estaba viendo (en el móvil es un carrusel)
      const i = conImagen[actual].i;
      if (carril.scrollWidth > carril.clientWidth) carril.scrollTo({ left: i * carril.clientWidth, behavior: 'auto' });
      if (volverA && volverA.focus) volverA.focus({ preventScroll: true });
      if (!desdeHistorial && history.state && history.state.mtVisor) history.back();
    };
    window.addEventListener('popstate', () => { if (abierto) cerrar(true); });
    const elegirBtn = visor.querySelector('[data-visor-elegir]');
    if (elegirBtn) elegirBtn.addEventListener('click', () => {
      cerrar(false);
      // después de volver atrás en el historial (el navegador puede recolocar la página), se baja a la talla del pack elegido
      setTimeout(() => {
        const destino = $('[data-mt-opciones].es-dentro') || $('.mt-opciones--uno') || $('#elegir-pack') || $('[data-mt-opciones]');
        if (!destino) return;
        const suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, destino.getBoundingClientRect().top + window.scrollY - 90), behavior: suave ? 'smooth' : 'auto' });
      }, 300);
    });

    // Abrir: pulsar una foto de la galería, la lupa o Intro con el carrusel enfocado
    carril.addEventListener('click', (e) => {
      const foto = e.target.closest('[data-mt-foto]');
      if (!foto || !foto.querySelector('img')) return;
      abrir(fotos.indexOf(foto));
    });
    const lupa = $('[data-mt-ampliar]');
    if (lupa) {
      lupa.addEventListener('click', () => {
        const i = carril.scrollWidth > carril.clientWidth ? Math.round(carril.scrollLeft / carril.clientWidth) : 0;
        abrir(i);
      });
    }
    carril.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      abrir(carril.scrollWidth > carril.clientWidth ? Math.round(carril.scrollLeft / carril.clientWidth) : 0);
    });

    // Dentro del visor
    cerrarBtn.addEventListener('click', () => cerrar(false));
    visor.querySelectorAll('[data-visor-paso]').forEach((b) =>
      b.addEventListener('click', () => { reducir(); ir(actual + parseInt(b.dataset.visorPaso, 10), true); })
    );
    let tras = false;
    pista.addEventListener('scroll', () => {
      if (tras || visor.classList.contains('es-ampliado')) return;
      tras = true;
      requestAnimationFrame(() => {
        tras = false;
        const k = Math.round(pista.scrollLeft / pista.clientWidth);
        if (k !== actual) { actual = k; cuenta.textContent = String(k + 1); cargar(k); }
      });
    }, { passive: true });
    // Con ratón, la foto ampliada se mueve arrastrando; un clic sin arrastrar la devuelve a su tamaño
    let arrastre = null;
    let sinClic = false;
    pista.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      const m = e.target.closest('.mt-visor__foto.es-ampliada');
      if (!m) return;
      e.preventDefault();
      arrastre = { m, x: e.clientX, y: e.clientY, l: m.scrollLeft, t: m.scrollTop, movido: false };
    });
    window.addEventListener('pointermove', (e) => {
      if (!arrastre) return;
      const dx = e.clientX - arrastre.x;
      const dy = e.clientY - arrastre.y;
      if (Math.abs(dx) + Math.abs(dy) > 4) arrastre.movido = true;
      arrastre.m.scrollLeft = arrastre.l - dx;
      arrastre.m.scrollTop = arrastre.t - dy;
    });
    window.addEventListener('pointerup', () => {
      if (arrastre && arrastre.movido) { sinClic = true; setTimeout(() => { sinClic = false; }, 0); }
      arrastre = null;
    });
    pista.addEventListener('click', (e) => {
      if (sinClic) return;
      const m = e.target.closest('.mt-visor__foto');
      if (!m) return;
      if (m.classList.contains('es-ampliada')) { reducir(); return; }
      if (e.target.tagName === 'IMG') ampliar(m, e.clientX, e.clientY);
      else cerrar(false); // pulsar el fondo oscuro, fuera de la foto, cierra
    });
    document.addEventListener('keydown', (e) => {
      if (!abierto) return;
      if (e.key === 'Escape') { e.preventDefault(); if (visor.classList.contains('es-ampliado')) reducir(); else cerrar(false); }
      else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); reducir(); ir(actual + (e.key === 'ArrowRight' ? 1 : -1), true); }
      else if (e.key === 'Tab') {
        // el foco no sale del visor
        const botones = Array.from(visor.querySelectorAll('button'));
        const i = botones.indexOf(document.activeElement);
        e.preventDefault();
        botones[(i + (e.shiftKey ? -1 : 1) + botones.length) % botones.length].focus();
      }
    });
    window.addEventListener('resize', () => { if (abierto && !visor.classList.contains('es-ampliado')) ir(actual, false); });
  })();

  /* ---------- Columna de compra fija (escritorio) ---------- */
  // Si la columna es más alta que la pantalla, se fija por abajo para que el botón de compra no se pierda.
  (function columna() {
    const columna = $('.mt-compra');
    if (!columna) return;
    const ajustar = () => {
      if (window.innerWidth < 990) {
        columna.style.top = '';
        return;
      }
      const cabecera = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mt-header-h')) || 72;
      columna.style.top = `${Math.min(cabecera + 24, window.innerHeight - columna.offsetHeight - 24)}px`;
    };
    ajustar();
    window.addEventListener('resize', ajustar, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(ajustar).observe(columna);
  })();

  /* ---------- Estado de la compra ---------- */
  // v5.6 · formato Nubelina: una fila de talla por par. Al elegir la del par 1, los demás pares que no se han tocado la copian.
  const nOpciones = datos.sinVariantes ? 0 : datos.opciones.length;
  const valoresDe = (i) => Array.from(new Set(datos.variantes.map((v) => v.opciones[i])));
  const decidibles = [];
  for (let i = 0; i < nOpciones; i += 1) if (valoresDe(i).length > 1) decidibles.push(i);
  const indiceTalla = datos.opciones.findIndex((o) => /talla|size|tama/i.test(o));
  // 27/10 · como Kintoe: un color y una talla para todo el pack, elegidos arriba
  const unColor = !!datos.unColor && nOpciones > 0;
  // 06/10 · el color se elige en círculos. El tinte de cada nombre sale del ajuste «Colores» («Nombre: #RRGGBB»; «transparente» =
  // círculo de cristal). Un nombre que no esté en la lista sale en gris neutro con su nombre al lado: nunca un color inventado.
  const indiceColor = nOpciones ? datos.opciones.findIndex((o) => /colou?r/i.test(o)) : -1;
  const tintes = {};
  String(datos.colores || '').split(/\r?\n/).forEach((linea) => {
    const k = linea.indexOf(':');
    if (k < 1) return;
    const nombre = linea.slice(0, k).trim().toLowerCase();
    const valor = linea.slice(k + 1).trim();
    if (nombre && valor) tintes[nombre] = valor;
  });
  const estado = {
    pares: datos.presel,
    base: Array(nOpciones).fill(null), // opciones del par 1
    personalizar: true, // cada par tiene su fila (los pares 2…N viven en extra)
    extra: [], // opciones de los pares 2…N
    mismaTalla: true, // 18/10 · una sola talla para todos los pares (la casilla se puede quitar)
  };
  // Una opción con un solo valor (p. ej. un único color) no es una decisión: se elige sola.
  for (let i = 0; i < nOpciones; i += 1) {
    const valores = valoresDe(i);
    if (valores.length === 1) estado.base[i] = valores[0];
  }
  // El color de la primera variante en venta sale ya marcado (se cambia con un toque); la talla no: esa la decide cada uno.
  if (indiceColor >= 0 && !estado.base[indiceColor]) {
    const primera = datos.variantes.find((v) => v.disponible);
    if (primera) estado.base[indiceColor] = primera.opciones[indiceColor];
  }
  const ajustarPares = () => {
    estado.extra.length = Math.max(0, estado.pares - 1);
    for (let p = 0; p < estado.pares - 1; p += 1) if (!estado.extra[p]) estado.extra[p] = estado.base.slice();
  };
  ajustarPares();

  // 26/10 (auditoría, research/19 A3): el color se elige UNA vez para todo el pack («Uno de cada» o un solo color), con
  // «Elegir color par a par» para quien quiera mezclar a su manera. Con un color por par, Clarity contaba 79 toques a colores
  // frente a 30 a tallas, y quien compraba tardaba hasta 2 minutos en elegirlos uno a uno.
  const SURTIDO = 'surtido';
  const hayColorPack = indiceColor >= 0 && decidibles.includes(indiceColor);
  // Orden de «Uno de cada»: el del ajuste de la sección (por ventas) y, detrás, los colores que falten, en el orden del producto.
  const coloresSurtido = () => {
    const todos = valoresDe(indiceColor);
    const orden = (datos.surtido || []).map((x) => String(x).trim()).filter((x) => todos.includes(x));
    todos.forEach((x) => { if (!orden.includes(x)) orden.push(x); });
    return orden;
  };
  if (hayColorPack) {
    estado.modoColor = 'pack';
    estado.colorPack = estado.pares > 1 ? SURTIDO : coloresSurtido()[0];
    estado.colorElegido = false; // hasta que se toque un color: «Uno de cada» con 2 pares o más y el primero de la lista con 1
    // 27/10 · como Kintoe sale marcado el color de la primera variante en venta, que es el de la primera foto
    if (unColor) estado.colorPack = estado.base[indiceColor] || coloresSurtido()[0];
  }

  // 08/10 · color con el que arranca la ficha (el primero en venta): la galería solo salta cuando cambia respecto a este.
  let ultimoColorGaleria = indiceColor >= 0 ? estado.base[indiceColor] || '' : '';
  const el = {
    total: $('[data-mt-total]'),
    antes: $('[data-mt-antes]'),
    ahorro: $('[data-mt-ahorro]'),
    peldanos: $$('[data-mt-peldano]'),
    paresLista: $('[data-mt-pares-lista]'),
    paresNota: $('[data-mt-pares-nota]'),
    error: $('[data-mt-error]'),
    errorCarrito: $('[data-mt-error-carrito]'),
    cta: $('[data-mt-cta]'),
    ctaTexto: $('[data-mt-cta-texto]'),
    ctaTotal: $('[data-mt-cta-total]'),
    fija: document.querySelector('[data-mt-fija]'),
    par: $('[data-mt-par]'), // 18/10 · precio por par junto al precio principal
  };
  if (el.fija) {
    el.fijaTotal = el.fija.querySelector('[data-mt-fija-total]');
    el.fijaTexto = el.fija.querySelector('[data-mt-fija-texto]');
    el.fijaCta = el.fija.querySelector('[data-mt-fija-cta]');
    el.fijaAntes = el.fija.querySelector('[data-mt-fija-antes]');
    el.fijaPar = el.fija.querySelector('[data-mt-fija-par]');
  }

  const variantePara = (opciones) => (datos.sinVariantes ? datos.variantes[0] : datos.variantes.find((v) => v.opciones.every((valor, i) => valor === opciones[i])));
  const completo = (opciones) => opciones.every((v) => v !== null && v !== undefined && v !== '');
  const opcionesDelPar = (i) => (i === 0 ? estado.base : estado.extra[i - 1] || estado.base);
  const todosCompletos = () => Array.from({ length: estado.pares }, (_, i) => completo(opcionesDelPar(i))).every(Boolean);

  // Pares → líneas de carrito agrupadas por variante
  function lineas() {
    const mapa = new Map();
    for (let i = 0; i < estado.pares; i += 1) {
      const variante = variantePara(opcionesDelPar(i));
      if (!variante) return null;
      mapa.set(variante.id, { variante, cantidad: (mapa.get(variante.id) || { cantidad: 0 }).cantidad + 1 });
    }
    return Array.from(mapa.values());
  }

  // Importes de un pack de N pares. Con las variantes ya elegidas se calcula unidad a unidad (como Shopify);
  // si aún no hay talla, con el precio del producto.
  function importes(pares, usarSeleccion) {
    const pct = window.mtDescuento(pares);
    let bruto = 0;
    let neto = 0;
    const filas = usarSeleccion ? lineas() : null;
    // Escalera de pares gratis: Shopify deja a 0 € las unidades más baratas.
    const gratis = window.mtGratis(pares);
    if (gratis > 0) {
      const precios = [];
      if (filas) filas.forEach(({ variante, cantidad }) => { for (let i = 0; i < cantidad; i += 1) precios.push(variante.precio); });
      else for (let i = 0; i < pares; i += 1) precios.push(datos.precio);
      precios.sort((x, y) => x - y);
      bruto = precios.reduce((s, p) => s + p, 0);
      neto = precios.slice(gratis).reduce((s, p) => s + p, 0);
      return { pct: bruto ? Math.floor(((bruto - neto) * 100) / bruto) : 0, gratis, bruto, total: neto, ahorro: bruto - neto, par: Math.round(neto / pares) };
    }
    // Como Shopify (comprobado en la tienda real): el porcentaje se aplica por unidad y el descuento se redondea hacia abajo.
    const unidad = (precio) => precio - Math.floor((precio * pct) / 100);
    if (filas) {
      filas.forEach(({ variante, cantidad }) => {
        bruto += variante.precio * cantidad;
        neto += unidad(variante.precio) * cantidad;
      });
    } else {
      bruto = datos.precio * pares;
      neto = unidad(datos.precio) * pares;
    }
    return { pct: bruto ? Math.floor(((bruto - neto) * 100) / bruto) : 0, bruto, total: neto, ahorro: bruto - neto, par: Math.round(neto / pares) };
  }

  /* ---------- 26/10 · Color del pack (A3) ---------- */
  function colorDelPack() {
    return estado.colorPack === SURTIDO && estado.pares < 2 ? coloresSurtido()[0] : estado.colorPack;
  }
  // Pone el color de cada par según lo elegido para el pack. «Uno de cada» va por la lista y salta un color agotado en la talla de ese par.
  function aplicarColorPack() {
    if (!hayColorPack || estado.modoColor !== 'pack') return;
    ajustarPares();
    const orden = coloresSurtido();
    const eleccion = colorDelPack();
    let siguiente = 0;
    for (let p = 0; p < estado.pares; p += 1) {
      const ops = p === 0 ? estado.base : estado.extra[p - 1];
      let color = eleccion;
      if (eleccion === SURTIDO) {
        color = orden[siguiente % orden.length];
        for (let n = 0; n < orden.length; n += 1) {
          const c = orden[(siguiente + n) % orden.length];
          if (hayEnVenta(ops, indiceColor, c)) {
            color = c;
            siguiente += n;
            break;
          }
        }
        siguiente += 1;
      }
      ops[indiceColor] = color;
    }
    // Mientras no se elija un color concreto, la galería no salta a la foto de un color.
    if (!estado.colorElegido || estado.colorPack === SURTIDO) ultimoColorGaleria = estado.base[indiceColor] || ultimoColorGaleria;
  }
  // «Uno de cada: negro y gris.» · «Repartidos: 2 negros, 2 grises y 1 azul marino.» · «Los 3 pares, en gris.»
  function resumenColores() {
    const cuenta = new Map();
    for (let p = 0; p < estado.pares; p += 1) {
      const c = opcionesDelPar(p)[indiceColor];
      if (c) cuenta.set(c, (cuenta.get(c) || 0) + 1);
    }
    const nombre = (c, n) => {
      const m = String(c).toLowerCase();
      if (n < 2 || /\s/.test(m)) return m;
      return /[aeiouáéíóú]$/.test(m) ? `${m}s` : `${m}es`;
    };
    const lista = (xs) => (xs.length > 1 ? `${xs.slice(0, -1).join(', ')} y ${xs[xs.length - 1]}` : xs[0] || '');
    if (cuenta.size === 1) return `${estado.pares > 1 ? `Los ${estado.pares} pares` : 'El par'}, en ${nombre([...cuenta.keys()][0], 1)}.`;
    const unoDeCada = [...cuenta.values()].every((n) => n === 1);
    const partes = [...cuenta.entries()].map(([c, n]) => (unoDeCada ? nombre(c, 1) : `${n} ${nombre(c, n)}`));
    return `${unoDeCada ? 'Uno de cada' : 'Repartidos'}: ${lista(partes)}.`;
  }
  function htmlColorPack() {
    const orden = coloresSurtido();
    const eleccion = colorDelPack();
    if (unColor) {
      // 27/10 · como Kintoe: círculos grandes, en el orden del producto, y el color elegido escrito en el título
      const circulos = valoresDe(indiceColor)
        .map((c) => {
          const ok = hayEnVenta(estado.base, indiceColor, c);
          const t = tinte(c);
          const marcado = eleccion === c;
          return `<label class="mt-color mt-color--grande${marcado ? ' es-elegido' : ''}${ok ? '' : ' es-agotado'}" title="${escapar(c)}${ok ? '' : ' (agotado)'}"><input type="radio" name="mt-color-pack" value="${escapar(c)}" data-mt-color-pack${marcado ? ' checked' : ''}${ok ? '' : ' disabled'}><span class="mt-color__punto${t.clase}"${t.estilo}></span><span class="mt-oculto">${escapar(c)}${ok ? '' : ' (agotado)'}</span></label>`;
        })
        .join('');
      return `<fieldset class="mt-opcion mt-colores-pack mt-colores-pack--uno"><legend class="mt-colores-pack__titulo">${escapar(datos.opciones[indiceColor])}: <b>${escapar(eleccion || '')}</b></legend><span class="mt-colores">${circulos}</span></fieldset>`;
    }
    const punto = (c) => {
      const t = tinte(c);
      return `<i class="mt-color__punto${t.clase}"${t.estilo} aria-hidden="true"></i>`;
    };
    const chip = (valor, etiqueta, dibujo, clase = '') =>
      `<label class="mt-valor mt-valor--color${clase}"><input type="radio" name="mt-color-pack" value="${escapar(valor)}" data-mt-color-pack${eleccion === valor ? ' checked' : ''}><span>${dibujo}<b>${escapar(etiqueta)}</b></span></label>`;
    const chips = [];
    if (estado.pares > 1 && orden.length > 1) chips.push(chip(SURTIDO, 'Uno de cada', `<i class="mt-valor__puntos" aria-hidden="true">${orden.slice(0, 3).map(punto).join('')}</i>`, ' mt-valor--surtido'));
    orden.forEach((c) => chips.push(chip(c, c, punto(c))));
    const pie = estado.pares > 1 ? `<p class="mt-colores-pack__nota" data-mt-color-resumen>${escapar(resumenColores())}</p><button type="button" class="mt-pares__modo" data-mt-color-modo="par">Elegir color par a par</button>` : '';
    return `<fieldset class="mt-opcion mt-colores-pack"><legend class="mt-colores-pack__titulo">${escapar(datos.opciones[indiceColor])}</legend><div class="mt-opcion__valores mt-colores-pack__valores">${chips.join('')}</div>${pie}</fieldset>`;
  }

  /* ---------- Pintar ---------- */
  function pintarPeldanos() {
    el.peldanos.forEach((peldano) => {
      const n = parseInt(peldano.dataset.mtPeldano, 10);
      const imp = importes(n, false);
      const total = peldano.querySelector('[data-mt-peldano-total]');
      const par = peldano.querySelector('[data-mt-peldano-par]');
      const antes = peldano.querySelector('[data-mt-peldano-antes]');
      if (total) total.textContent = dinero(imp.total);
      if (par) par.textContent = `${dinero(imp.par)}/par`;
      if (antes) {
        antes.hidden = imp.ahorro === 0;
        antes.textContent = dinero(imp.bruto);
      }
      peldano.classList.toggle('es-activo', n === estado.pares);
      const pack = peldano.closest('[data-mt-pack]');
      if (pack) pack.classList.toggle('es-activo', n === estado.pares);
    });
  }

  const escapar = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  // ¿Hay alguna variante en venta con este valor, respetando lo ya elegido en las otras opciones de ese par?
  const hayEnVenta = (opciones, i, valor) => {
    const prueba = opciones.slice();
    prueba[i] = valor;
    return datos.variantes.some((v) => v.disponible && prueba.every((x, k) => x === null || x === undefined || x === '' || v.opciones[k] === x));
  };
  const tinte = (valor) => {
    const v = tintes[String(valor).toLowerCase()];
    if (!v) return { clase: ' es-sin-color', estilo: '' };
    if (/^transparen/i.test(v)) return { clase: ' es-transparente', estilo: '' };
    return { clase: '', estilo: ` style="--c: ${escapar(v)}"` };
  };
  // Miniatura de un par: la foto de su variante (o la de otra variante de su mismo color) si la tiene; si no, la del producto.
  const miniaturaDe = (ops) => {
    let v = variantePara(ops);
    if ((!v || !v.imagen) && indiceColor >= 0 && ops[indiceColor]) v = datos.variantes.find((x) => x.opciones[indiceColor] === ops[indiceColor] && x.imagen);
    return (v && v.imagen) || datos.miniatura;
  };

  // 18/10 · botones de talla (S · 35–38) de un par (o de todos, con par = 'all'), con los agotados tachados.
  const botonesTalla = (ops, par, nombreCampo) =>
    valoresDe(indiceTalla)
      .map((valor) => {
        const ok = hayEnVenta(ops, indiceTalla, valor);
        const pista = datos.pistas && datos.pistas[valor] ? `<small>${escapar(datos.pistas[valor])}</small>` : '';
        const marcado = ops[indiceTalla] === valor;
        return `<label class="mt-valor"><input type="radio" name="${nombreCampo}" value="${escapar(valor)}" data-par="${par}" data-opcion="${indiceTalla}"${marcado ? ' checked' : ''}${ok ? '' : ' disabled'}><span>${escapar(valor)}${pista}${ok ? '' : '<small>agotado</small>'}</span></label>`;
      })
      .join('');
  // ¿Se elige la talla una sola vez para todos los pares? (casilla marcada, o un solo par)
  const tallaUnica = () => indiceTalla >= 0 && decidibles.includes(indiceTalla) && (estado.mismaTalla || estado.pares < 2);

  // Arriba, los botones de talla (una sola vez) y la casilla «Misma talla en todos los pares»; después, una fila por par:
  // miniatura, «Par N» y lo que decide ese par (el color en círculos; la talla en botones solo si la casilla está sin marcar).
  function pintarPares() {
    if (!el.paresLista) return;
    ajustarPares();
    if (!decidibles.length) {
      el.paresLista.innerHTML = '';
      if (el.paresNota) el.paresNota.hidden = true;
      return;
    }
    const unica = tallaUnica();
    const conColorPack = hayColorPack && estado.modoColor === 'pack';
    if (conColorPack) aplicarColorPack();
    const porPar = decidibles.filter((i) => !(unica && i === indiceTalla) && !(conColorPack && i === indiceColor));
    if (el.paresNota) el.paresNota.hidden = estado.pares < 2 || !porPar.length;
    const filas = [];
    let tallaTodos = '';
    if (unica) {
      // 27/10 · como Kintoe, el título de la talla a la vista y la talla elegida al lado
      const nombreTalla = escapar(datos.opciones[indiceTalla]);
      const elegida = estado.base[indiceTalla];
      const titulo = unColor ? `<legend class="mt-colores-pack__titulo">${nombreTalla}${elegida ? `: <b>${escapar(elegida)}</b>` : ''}</legend>` : `<legend class="mt-oculto">${nombreTalla}</legend>`;
      tallaTodos = `<fieldset class="mt-opcion mt-tallas-botones" data-mt-talla-todos>${titulo}<div class="mt-opcion__valores">${botonesTalla(estado.base, 'all', 'mt-talla-todos')}</div></fieldset>`;
    }
    if (unColor) {
      // 27/10 · como Kintoe: primero el color y debajo la talla, sin la casilla «Misma talla en todos los pares»
      if (conColorPack) filas.push(htmlColorPack());
      if (tallaTodos) filas.push(tallaTodos);
    } else {
      if (tallaTodos) filas.push(tallaTodos);
      if (indiceTalla >= 0 && decidibles.includes(indiceTalla) && estado.pares > 1) {
        filas.push(`<label class="mt-pares__misma"><input type="checkbox" data-mt-misma${estado.mismaTalla ? ' checked' : ''}><span>Misma talla en todos los pares</span></label>`);
      }
      if (conColorPack) filas.push(htmlColorPack());
    }
    for (let p = 0; p < estado.pares && porPar.length; p += 1) {
      const ops = opcionesDelPar(p);
      const campos = porPar
        .map((i) => {
          const nombre = datos.opciones[i];
          if (i === indiceTalla) {
            return `<fieldset class="mt-pares__campo mt-pares__campo--talla"><legend class="mt-oculto">Par ${p + 1}: ${escapar(nombre)}</legend><div class="mt-opcion__valores mt-opcion__valores--par">${botonesTalla(ops, p, `mt-talla-par-${p}`)}</div></fieldset>`;
          }
          if (i === indiceColor) {
            const circulos = valoresDe(i)
              .map((valor) => {
                const ok = hayEnVenta(ops, i, valor);
                const t = tinte(valor);
                const marcado = ops[i] === valor;
                return `<label class="mt-color${marcado ? ' es-elegido' : ''}${ok ? '' : ' es-agotado'}" title="${escapar(valor)}${ok ? '' : ' (agotado)'}"><input type="radio" name="mt-color-par-${p}" value="${escapar(valor)}" data-par="${p}" data-opcion="${i}"${marcado ? ' checked' : ''}${ok ? '' : ' disabled'}><span class="mt-color__punto${t.clase}"${t.estilo}></span><span class="mt-oculto">${escapar(valor)}${ok ? '' : ' (agotado)'}</span></label>`;
              })
              .join('');
            return `<fieldset class="mt-pares__campo mt-pares__campo--color"><legend class="mt-oculto">Par ${p + 1}: ${escapar(nombre)}</legend><span class="mt-colores">${circulos}</span><span class="mt-colores__nombre" data-mt-color-nombre="${p}" aria-hidden="true">${escapar(ops[i] || nombre)}</span></fieldset>`;
          }
          const opciones = valoresDe(i)
            .map((valor) => {
              const ok = hayEnVenta(ops, i, valor);
              const pista = i === indiceTalla && datos.pistas && datos.pistas[valor] ? ` · ${datos.pistas[valor]}` : '';
              return `<option value="${escapar(valor)}"${ops[i] === valor ? ' selected' : ''}${ok ? '' : ' disabled'}>${escapar(valor)}${pista}${ok ? '' : ' (agotado)'}</option>`;
            })
            .join('');
          const vacio = `<option value=""${ops[i] ? '' : ' selected'} disabled>${escapar(nombre)}${estado.pares > 1 ? ` del par ${p + 1}` : ''}</option>`;
          return `<label class="mt-pares__campo"><span class="mt-oculto">Par ${p + 1}: ${escapar(nombre)}</span><select data-par="${p}" data-opcion="${i}"${ops[i] ? '' : ' class="es-vacio"'}>${vacio}${opciones}</select></label>`;
        })
        .join('');
      const foto = miniaturaDe(ops);
      const mini = foto ? `<img class="mt-pares__mini" src="${escapar(foto)}" alt="" width="44" height="44">` : '';
      const num = estado.pares > 1 ? `<span class="mt-pares__num">Par ${p + 1}</span>` : '';
      filas.push(`<div class="mt-pares__fila" data-fila="${p}"><div class="mt-pares__quien">${mini}${num}</div><div class="mt-pares__campos">${campos}</div></div>`);
    }
    if (hayColorPack && !conColorPack && estado.pares > 1) filas.push('<button type="button" class="mt-pares__modo" data-mt-color-modo="pack">Un color para todo el pack</button>');
    el.paresLista.innerHTML = filas.join('');
  }

  // Sin volver a pintar las filas (para no perder el foco): pone en cada desplegable el valor que toca.
  function sincronizarPares() {
    if (!el.paresLista) return;
    $$('select[data-par]', el.paresLista).forEach((s) => {
      const ops = opcionesDelPar(parseInt(s.dataset.par, 10));
      const valor = ops[parseInt(s.dataset.opcion, 10)] || '';
      if (s.value !== valor) s.value = valor;
      s.classList.toggle('es-vacio', !valor);
      if (valor) s.closest('.mt-pares__fila').classList.remove('es-error');
    });
    // Círculos de color y botones de talla (de un par, o de todos con par = 'all'): el marcado, el nombre que se lee al lado y la miniatura del par.
    $$('input[data-par]', el.paresLista).forEach((r) => {
      const ops = opcionesDelPar(r.dataset.par === 'all' ? 0 : parseInt(r.dataset.par, 10));
      const marcado = ops[parseInt(r.dataset.opcion, 10)] === r.value;
      if (r.checked !== marcado) r.checked = marcado;
      const circulo = r.closest('.mt-color');
      if (circulo) circulo.classList.toggle('es-elegido', marcado);
      if (marcado) {
        const caja = r.closest('.mt-pares__fila, [data-mt-talla-todos]');
        if (caja) caja.classList.remove('es-error');
      }
    });
    $$('[data-mt-color-nombre]', el.paresLista).forEach((n) => {
      const valor = opcionesDelPar(parseInt(n.dataset.mtColorNombre, 10))[indiceColor];
      if (valor && n.textContent !== valor) n.textContent = valor;
    });
    $$('.mt-pares__fila', el.paresLista).forEach((fila) => {
      const img = fila.querySelector('.mt-pares__mini');
      const foto = miniaturaDe(opcionesDelPar(parseInt(fila.dataset.fila, 10)));
      if (img && foto && img.getAttribute('src') !== foto) img.setAttribute('src', foto);
    });
    // 26/10 · color del pack: el marcado y la frase con el reparto
    const eleccionPack = hayColorPack && estado.modoColor === 'pack' ? colorDelPack() : null;
    $$('input[data-mt-color-pack]', el.paresLista).forEach((r) => {
      const m = r.value === eleccionPack;
      if (r.checked !== m) r.checked = m;
      const circulo = r.closest('.mt-color'); // 27/10 · círculos grandes (como Kintoe)
      if (circulo) circulo.classList.toggle('es-elegido', m);
    });
    const frasePack = $('[data-mt-color-resumen]', el.paresLista);
    if (frasePack) frasePack.textContent = resumenColores();
    // 08/10 · avisa a la galería del color del primer par, solo cuando cambia (al cargar no salta).
    if (indiceColor >= 0) {
      const colorAhora = opcionesDelPar(0)[indiceColor] || '';
      if (colorAhora && colorAhora !== ultimoColorGaleria) {
        ultimoColorGaleria = colorAhora;
        raiz.dispatchEvent(new CustomEvent('mt:color', { detail: { color: colorAhora } }));
      }
    }
  }

  function textoOpciones(opciones) {
    return opciones.filter((v, i) => v && valoresDe(i).length > 1).join(' · ');
  }

  function pintarTotales() {
    const listo = todosCompletos();
    const imp = importes(estado.pares, listo);
    if (el.total) el.total.textContent = dinero(imp.total);
    if (el.antes) {
      el.antes.hidden = imp.ahorro === 0;
      el.antes.textContent = dinero(imp.bruto);
    }
    if (el.ahorro) {
      el.ahorro.hidden = imp.ahorro === 0;
      el.ahorro.textContent = `Ahorras ${dinero(imp.ahorro)}`;
    }
    if (el.ctaTotal) el.ctaTotal.textContent = `· ${dinero(imp.total)}`;
    if (el.fijaTotal) el.fijaTotal.textContent = dinero(imp.total);
    if (el.fijaAntes) { el.fijaAntes.hidden = imp.ahorro === 0; el.fijaAntes.textContent = dinero(imp.bruto); }
    if (el.fijaPar) { el.fijaPar.hidden = estado.pares < 2; el.fijaPar.textContent = `${dinero(imp.par)}/par`; }
    if (el.par) { el.par.hidden = estado.pares < 2; el.par.textContent = `${dinero(imp.par)}/par`; }
    if (el.fijaTexto) {
      let resumen = '';
      if (listo && decidibles.length) {
        const textos = Array.from({ length: estado.pares }, (_, i) => textoOpciones(opcionesDelPar(i)));
        resumen = ` · ${textos.every((x) => x === textos[0]) ? textos[0] : indiceColor >= 0 ? 'combinados' : 'tallas mezcladas'}`;
      }
      el.fijaTexto.textContent = `${plural(estado.pares)}${resumen}`;
    }
  }

  // La tarjeta del pack elegido «se abre»: las filas de talla se colocan dentro, entre la cabecera y los regalos.
  const bloqueOpciones = raiz.querySelector('[data-mt-opciones]');
  function colocarOpciones() {
    if (!bloqueOpciones || !el.peldanos.length) return;
    const activo = el.peldanos.find((p) => parseInt(p.dataset.mtPeldano, 10) === estado.pares);
    // 27/10 · como Kintoe, el color y la talla se quedan arriba; la tarjeta elegida solo se abre para enseñar sus regalos
    if (!unColor && activo && activo.nextElementSibling !== bloqueOpciones) activo.after(bloqueOpciones);
    bloqueOpciones.classList.toggle('es-dentro', !!activo && !unColor);
    el.peldanos.forEach((p) => {
      p.classList.toggle('es-abierto', p === activo);
      const pack = p.closest('[data-mt-pack]');
      if (pack) pack.classList.toggle('es-abierto', p === activo);
    });
  }

  function pintar() {
    colocarOpciones();
    pintarPeldanos();
    pintarPares();
    pintarTotales();
  }

  /* ---------- Eventos ---------- */
  const elegirPack = (n) => {
    estado.pares = n;
    if (hayColorPack && !estado.colorElegido && !unColor) estado.colorPack = n > 1 ? SURTIDO : coloresSurtido()[0];
    ajustarPares();
    pintar();
  };
  // 27/10 · como Kintoe: tras elegir color o talla se vuelve a pintar (así se tacha lo que no queda en venta con lo elegido) y el foco vuelve a su botón
  function repintarOpciones() {
    const activo = document.activeElement;
    const clave = activo && el.paresLista && el.paresLista.contains(activo) && activo.name ? [activo.name, activo.value] : null;
    pintarPares();
    sincronizarPares();
    if (!clave) return;
    const mismo = $$('input', el.paresLista).find((r) => r.name === clave[0] && r.value === clave[1]);
    if (mismo) mismo.focus({ preventScroll: true });
  }
  el.peldanos.forEach((peldano) => {
    const input = peldano.querySelector('input');
    input.addEventListener('change', () => elegirPack(parseInt(input.value, 10)));
  });
  // Como en Nubelina, toda la tarjeta elige el pack (también la zona de regalos), salvo los controles de dentro.
  $$('[data-mt-pack]').forEach((pack) => {
    pack.addEventListener('click', (e) => {
      if (e.target.closest('select, button, a, label.mt-peldano, input')) return;
      const input = pack.querySelector('[data-mt-peldano] input');
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  // Cambia una opción de un par. Si es el par 1, los demás pares que seguían su valor (o estaban sin elegir) lo copian.
  function ponerOpcion(par, i, valor) {
    if (i === indiceTalla && estado.mismaTalla) {
      // 18/10 · una sola talla para todos los pares
      estado.base[i] = valor;
      estado.extra.forEach((ops) => { if (ops) ops[i] = valor; });
      return;
    }
    if (par === 0) {
      const anterior = estado.base[i];
      estado.base[i] = valor;
      estado.extra.forEach((ops) => {
        if (ops && (ops[i] === anterior || ops[i] === null || ops[i] === undefined || ops[i] === '')) ops[i] = valor;
      });
    } else if (estado.extra[par - 1]) {
      estado.extra[par - 1][i] = valor;
    }
  }
  if (el.paresLista) {
    el.paresLista.addEventListener('change', (e) => {
      const misma = e.target.closest('input[data-mt-misma]');
      if (misma) {
        // 18/10 · al marcar la casilla, la talla del par 1 pasa a todos; al quitarla, cada par conserva la suya y puede cambiarla.
        estado.mismaTalla = misma.checked;
        if (estado.mismaTalla && indiceTalla >= 0 && estado.base[indiceTalla]) {
          estado.extra.forEach((ops) => { if (ops) ops[indiceTalla] = estado.base[indiceTalla]; });
        }
        if (el.error) el.error.hidden = true;
        pintarPares();
        pintarTotales();
        const casilla = $('[data-mt-misma]', el.paresLista);
        if (casilla) casilla.focus({ preventScroll: true });
        return;
      }
      const colorPackInput = e.target.closest('input[data-mt-color-pack]');
      if (colorPackInput) {
        estado.colorPack = colorPackInput.value;
        estado.colorElegido = true;
        aplicarColorPack();
        if (el.error) el.error.hidden = true;
        if (unColor) repintarOpciones();
        else sincronizarPares();
        pintarTotales();
        return;
      }
      const campo = e.target.closest('select[data-par], input[data-par]');
      if (!campo) return;
      ponerOpcion(campo.dataset.par === 'all' ? 0 : parseInt(campo.dataset.par, 10), parseInt(campo.dataset.opcion, 10), campo.value);
      aplicarColorPack();
      if (el.error) el.error.hidden = true;
      if (unColor) repintarOpciones();
      else sincronizarPares();
      pintarTotales();
    });
    // 26/10 · «Elegir color par a par» / «Un color para todo el pack»
    el.paresLista.addEventListener('click', (e) => {
      const boton = e.target.closest('[data-mt-color-modo]');
      if (!boton) return;
      estado.modoColor = boton.dataset.mtColorModo === 'par' ? 'par' : 'pack';
      if (estado.modoColor === 'pack' && !estado.colorElegido) estado.colorPack = estado.pares > 1 ? SURTIDO : coloresSurtido()[0];
      pintarPares();
      pintarTotales();
      const primero = $(estado.modoColor === 'par' ? '.mt-pares__fila input' : '.mt-colores-pack input', el.paresLista);
      if (primero) primero.focus({ preventScroll: true });
    });
  }

  function avisarFalta() {
    let fila = null;
    // 18/10 · con una sola talla para todos, si falta la talla la caja que se sacude es la de los botones de arriba
    if (tallaUnica() && !estado.base[indiceTalla] && el.paresLista) fila = el.paresLista.querySelector('[data-mt-talla-todos]');
    for (let p = 0; p < estado.pares && !fila; p += 1) {
      if (!completo(opcionesDelPar(p)) && el.paresLista) fila = el.paresLista.querySelector(`[data-fila="${p}"]`);
    }
    if (el.error) {
      const porPares = indiceTalla >= 0 && !estado.mismaTalla && estado.pares > 1;
      el.error.textContent = porPares ? 'Elige la talla de cada par para continuar.' : datos.textos.falta;
      el.error.hidden = false;
    }
    if (!fila) return;
    fila.classList.remove('es-error');
    void fila.offsetWidth; // reinicia la animación
    fila.classList.add('es-error');
    const caja = fila.getBoundingClientRect();
    if (caja.top < 90 || caja.bottom > window.innerHeight - 110) {
      window.scrollTo({ top: window.scrollY + caja.top - window.innerHeight * 0.3, behavior: 'smooth' });
    }
    const grupos = fila.matches('[data-mt-talla-todos]') ? [fila] : Array.from(fila.querySelectorAll('.mt-pares__campo--color, .mt-pares__campo--talla'));
    const vacio =
      Array.from(fila.querySelectorAll('select')).find((s) => !s.value) ||
      grupos.map((g) => (g.querySelector('input:checked') ? null : g.querySelector('input:not(:disabled)'))).find(Boolean) ||
      fila.querySelector('select, input');
    if (vacio) vacio.focus({ preventScroll: true });
  }

  let ocupado = false;
  async function anadir() {
    if (ocupado || !datos.disponible) return;
    if (!todosCompletos()) {
      avisarFalta();
      return;
    }
    const filas = lineas();
    if (!filas) {
      avisarFalta();
      return;
    }
    const agotada = filas.find((f) => !f.variante.disponible);
    if (agotada) {
      if (el.errorCarrito) {
        el.errorCarrito.textContent = indiceColor >= 0 ? 'Una de las combinaciones de talla y color está agotada. Cámbiala para continuar.' : 'Una de las tallas elegidas está agotada. Cámbiala para continuar.';
        el.errorCarrito.hidden = false;
      }
      return;
    }
    ocupado = true;
    if (el.errorCarrito) el.errorCarrito.hidden = true;
    const textoAntes = el.ctaTexto.textContent;
    [el.cta, el.fijaCta].forEach((b) => b && b.classList.add('es-cargando'));
    el.ctaTexto.textContent = datos.textos.anadiendo;
    try {
      await window.mtCarrito.anadir(filas.map((f) => ({ id: f.variante.id, quantity: f.cantidad })));
    } catch (error) {
      if (el.errorCarrito) {
        el.errorCarrito.textContent = error.message || 'No se pudo añadir al carrito. Inténtalo de nuevo.';
        el.errorCarrito.hidden = false;
        el.errorCarrito.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    } finally {
      ocupado = false;
      [el.cta, el.fijaCta].forEach((b) => b && b.classList.remove('es-cargando'));
      el.ctaTexto.textContent = textoAntes;
    }
  }
  if (el.cta) el.cta.addEventListener('click', anadir);
  if (el.fijaCta) el.fijaCta.addEventListener('click', anadir);

  /* ---------- Barra fija: aparece cuando el botón principal no está a la vista ---------- */
  if (el.fija && el.cta && 'IntersectionObserver' in window) {
    const mostrar = (ver) => {
      el.fija.classList.toggle('es-visible', ver);
      el.fija.setAttribute('aria-hidden', ver ? 'false' : 'true');
      if (el.fijaCta) el.fijaCta.tabIndex = ver ? 0 : -1;
    };
    // 19/10 (auditoría P2-2): tampoco mientras se ve el precio del bloque, que la barra tapaba en la primera pantalla.
    const precioBloque = document.querySelector('.mt-compra__precio');
    const vistos = new Map();
    const vigia = new IntersectionObserver((entradas) => {
      entradas.forEach((e) => vistos.set(e.target, e.isIntersecting));
      mostrar(![...vistos.values()].some(Boolean));
    }, { threshold: 0.4 });
    vigia.observe(el.cta);
    if (precioBloque) vigia.observe(precioBloque);
  }

  /* ---------- Buscador de talla: el módulo global avisa de la talla elegida y aquí se pone en el par 1 (y se copia) ---------- */
  document.addEventListener('mt:talla', (e) => {
    if (indiceTalla < 0) return;
    if (!hayEnVenta(estado.base, indiceTalla, e.detail.talla)) {
      if (el.error) {
        el.error.textContent = `La talla ${e.detail.talla} no está disponible ahora mismo.`;
        el.error.hidden = false;
      }
      return;
    }
    ponerOpcion(0, indiceTalla, e.detail.talla);
    aplicarColorPack();
    if (el.error) el.error.hidden = true;
    if (unColor) repintarOpciones();
    else sincronizarPares();
    pintarTotales();
  });

  /* ---------- Estado inicial desde la URL: ?pack=3 y ?variant=ID ---------- */
  const parametros = new URLSearchParams(window.location.search);
  let packUrl = parseInt(parametros.get('pack'), 10);
  // 27/10 · si ese pack no tiene tarjeta (p. ej. ?pack=2 de los correos, con las tarjetas 5 · 3 · 1), se abre el más pequeño que lo cubre
  const packsFicha = el.peldanos.map((p) => parseInt(p.dataset.mtPeldano, 10)).sort((x, y) => x - y);
  if (packUrl && packsFicha.length && !packsFicha.includes(packUrl)) packUrl = packsFicha.find((n) => n >= packUrl) || packsFicha[packsFicha.length - 1];
  if (packUrl && el.peldanos.some((p) => parseInt(p.dataset.mtPeldano, 10) === packUrl)) {
    estado.pares = packUrl;
    el.peldanos.forEach((p) => {
      p.querySelector('input').checked = parseInt(p.dataset.mtPeldano, 10) === packUrl;
    });
  }
  const varianteUrl = datos.variantes.find((v) => String(v.id) === parametros.get('variant'));
  if (varianteUrl && varianteUrl.disponible && nOpciones) {
    estado.base = varianteUrl.opciones.slice();
    estado.extra = [];
    if (hayColorPack) {
      estado.colorPack = estado.base[indiceColor];
      estado.colorElegido = true;
    }
  }
  ajustarPares();
  pintar();
})();
